module.exports = __webpack_public_path__ + "static/media/poolHeater2.c8a59e43.jpg";